import customAxios from '../utils/customAxios';
import {
  SentenceStatusApiRequestParam,
  SentenceStatusApiResponseParam,
} from '../types/apis/sentenceStatusApiType';

/**
 * センテンス再生状況保存API呼び出し
 * @param reqParams リクエストパラメータ
 * @returns APIレスポンスのPromise
 */
const callSentenceStatusAPI = (
  reqParams: SentenceStatusApiRequestParam,
): Promise<SentenceStatusApiResponseParam> => {
  const params = new URLSearchParams();
  params.append('accesskey', reqParams.accesskey);
  params.append('training_id', reqParams.trainingId.toString());
  params.append('sentence_id', reqParams.sentenceId);

  const response = customAxios
    .post<SentenceStatusApiResponseParam>(
      '/superelmer-server/sentence/status',
      params,
    )
    .then((res) => res.data);

  return response;
};

export default callSentenceStatusAPI;
